import { render, staticRenderFns } from "./registerDoctor.vue?vue&type=template&id=db1002b0&scoped=true&"
import script from "./registerDoctor.vue?vue&type=script&lang=js&"
export * from "./registerDoctor.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "db1002b0",
  null
  
)

export default component.exports